<template>
<div style="width:100%; padding-top: 40px">
  <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
    <div style="text-align:center">
      <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
      <screenButton class="screenButton"></screenButton>
    </div>
  </div>

  <b-table class="bgc-dark" small head-variant="dark" responsive bordered
           :items="items" :fields="fields" foot-clone>
    <template v-slot:head()="scope">
      <div class="text-nowrap" :style="{textAlign:'center'}">
        {{ scope.label }}
      </div>
    </template>
    <template v-slot:cell(index)="data">
      {{ data.index + 1 }}
    </template>
    <template v-slot:cell(subjectFullName)="data">
      <div @click="showDetail(data.item.subjectFullName)">{{ data.item.subjectFullName }}</div>
    </template>
    <template v-slot:cell(preAnnualPaidAmount)="data">
      {{ Number(data.item.preAnnualPaidAmount).toFixed(2) }}
    </template>
    <template v-slot:cell(currentAnnualBudgetAmount)="data">
      {{ Number(data.item.currentAnnualBudgetAmount).toFixed(2) }}
    </template>
    <template v-slot:cell(totalAdjustmentBudgetAmount)="data">
      {{ Number(data.item.totalAdjustmentBudgetAmount).toFixed(2) }}
    </template>
    <template v-slot:cell(beforeAdjustmentBudgetAmount)="data">
      {{ Number(data.item.beforeAdjustmentBudgetAmount).toFixed(2) }}
    </template>
    <template v-slot:cell(incurredBudgetAmount)="data">
      {{ Number(data.item.incurredBudgetAmount).toFixed(2) }}
    </template>
    <template v-slot:cell(adjustmentBudgetAmount)="data">
      {{ Number(data.item.adjustmentBudgetAmount).toFixed(2) }}
    </template>
    <template v-slot:cell(afterAdjustmentBudgetAmount)="data">
      {{ Number(data.item.afterAdjustmentBudgetAmount).toFixed(2) }}
    </template>
    <template v-slot:cell(remarks)="data">
      <div @click="showDetail(data.item.remarks)">{{ data.item.remarks }}</div>
    </template>

    <template v-slot:table-colgroup="scope">
      <col
          v-for="field in scope.fields"
          :key="field.key"
          :style="{ width: field.width }"
      >
    </template>
    <template v-slot:foot()="scope">
      <div class="text-nowrap" :style="{textAlign:'center'}"></div>
    </template>
    <template v-slot:foot(index)="data">
      <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
    </template>
    <template v-slot:foot(preAnnualPaidAmount)="data">
      <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'preAnnualPaidAmount')}}</div>
    </template>
    <template v-slot:foot(currentAnnualBudgetAmount)="data">
      <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'currentAnnualBudgetAmount')}}</div>
    </template>
    <template v-slot:foot(totalAdjustmentBudgetAmount)="data">
      <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'totalAdjustmentBudgetAmount')}}</div>
    </template>
    <template v-slot:foot(beforeAdjustmentBudgetAmount)="data">
      <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'beforeAdjustmentBudgetAmount')}}</div>
    </template>
    <template v-slot:foot(incurredBudgetAmount)="data">
      <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'incurredBudgetAmount')}}</div>
    </template>
    <template v-slot:foot(adjustmentBudgetAmount)="data">
      <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'adjustmentBudgetAmount')}}</div>
    </template>
    <template v-slot:foot(afterAdjustmentBudgetAmount)="data">
      <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'afterAdjustmentBudgetAmount')}}</div>
    </template>
  </b-table>
</div>
</template>

<script>
import {Decimal} from "decimal.js";

export default {
  name: "budgetPreparationAdjustDetail",
  data(){
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'subjectCode', label: '科目编码', width: '100px'},
        {key: 'subjectFullName', label: '科目名称', width: '150px'},
        {key: 'preAnnualPaidAmount', label: '上年度支出金额(元)', width: '130px'},
        {key: 'currentAnnualBudgetAmount', label: '年初预算金额(元)', width: '130px'},
        {key: 'totalAdjustmentBudgetAmount', label: '已调整金额(元)', width: '100px'},
        {key: 'beforeAdjustmentBudgetAmount', label: '调整后预算金额(元)', width: '130px'},
        {key: 'incurredBudgetAmount', label: '已发生金额(元)', width: '100px'},
        {key: 'adjustmentBudgetAmount', label: '本次申请调整金额(元)', width: '140px'},
        {key: 'afterAdjustmentBudgetAmount', label: '本次调整后金额(元)', width: '140px'},
        {key: 'remarks', label: '预算调整说明', width: '180px'},
      ],
      items: [],
    }
  },
  created(){
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init(){

    },
    goBack(){
      this.$router.back()
    },
    showDetail(content) {
      if(content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style scoped>

</style>